import './Hero.scss';
import React from 'react';
import HeroContent from '../../components/hero-components/HeroContent';
import { useInView } from 'react-intersection-observer';
import { useState ,useEffect} from 'react';

function Hero({t,data,handlerSelectModal,whiteBlock}) {
  const{ ref,inView } = useInView({
    threshold:0,
  });

  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth >= 460);

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth >= 460);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <div className="hero-wrapper">
      <div className="hero-content-wrapper">
        <div className="hero-content">
          <HeroContent t={t} data = {data}   handlerSelectModal={handlerSelectModal}/>
          <div ref={ref} className={`white-block-wrapper ${isWideScreen ? 'animation' : ''} ${inView && isWideScreen ? 'show-white': ""}`}>
            {whiteBlock}
          </div>
        </div>
      </div>
      <div className="hero-bottom"></div>
    </div>
  );
}

export default Hero;